import { useLocation, useNavigate, useParams } from "react-router-dom";
import { CircularProgress, Grid2 } from "@mui/material";
import React, { useEffect, useState } from "react";
import { OrgSettingsStyles } from ".";
import { Transfer } from "../../../../../../GlobalComponents/Transfer/Transfer";
import { DeleteComponent } from "../../../../../../GlobalComponents/DeleteComponent/DeleteComponent";
import UploadImage from "../../../../../../GlobalComponents/UploadImage/UploadImage";
import { useMakeApiCalls } from "../../../../../../Hooks/useMakeApiCalls";
import { Actions } from "../../../../../../redux/constants/actionTypes";
import { getStore } from "../../../../../../Utils/storeUtils";
import { useSelector } from "react-redux";
import CustomInput from "../../../../../../GlobalComponents/CustomInput/CustomInput";
import CustomButton from "../../../../../../GlobalComponents/CustomButton/CustomButton";
import FormPopup from "../../../../../../GlobalComponents/FormPopup/FormPopup";
import CheckCircleOutlineOutlinedIcon from "@mui/icons-material/CheckCircleOutlineOutlined";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { getRoleInOrg } from "../../../../../../Utils/organizations";
import PageLoading from "../../../../../../GlobalComponents/PageLoading/PageLoading";
import EditOrgImage from "./Components/EditOrgImage/EditOrgImage";
import { lastSegmentPath } from "../../../../../../Utils/roconConstants";
import { ReactComponent as Usa } from "../../../../../../GlobalAssets/svg/UsaSvg.svg";
import { ReactComponent as Indian } from "../../../../../../GlobalAssets/svg/IndianSvg.svg";
import { useEmailId } from "../../../../../../Utils/utils";

function OrganizationSettings() {
  const { orgId } = useParams();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [saveNameLoading, setSaveNameLoading] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const [transferLoading, setTransferLoading] = useState(false);
  const [nameLoading, setNameLoading] = useState(false);
  const [nameValid, setNameValid] = useState(null);
  const [uploadImg, setUploadImg] = useState(false);
  const [nameError, setNameError] = useState("");
  const [nameErrorMessage, setNameErrorMessage] = useState("");
  const emailId = useEmailId();
  const organizationsInfo = useSelector((state) => state.organizationsInfo);

  let orgName = useSelector(
    (state) => state?.organizationsInfo?.selectedOrg?.name,
  );

  const location = useLocation();
  const lastSegment = lastSegmentPath(location);

  const orgCountry = organizationsInfo?.selectedOrg?.country;

  const basePlan = useSelector(
    (state) => state.plansInfo?.specificPlan?.specificPlans,
  );

  const plan = basePlan?.find((item) => item.basePlan === true) || {};
  const cancel = plan?.cancel;
  const daysAfterExpiry = plan?.daysAfterExpiry;

  useMakeApiCalls(() => {
    getStore().dispatch({
      type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
      orgId: orgId,
    });
    getStore().dispatch({ type: Actions.API_USER_DETAILS });
    getStore().dispatch({
      type: Actions.SET_ORG_DETAILS,
      data: {
        orgId: orgId,
        orgPage: lastSegment,
      },
    });
  });

  const imagePath = organizationsInfo?.selectedOrg?.imagePath;

  const selectedOrg = useSelector(
    (state) => state.organizationsInfo.selectedOrg,
  );

  const orgOwner = selectedOrg?.ownerName;
  const [orgNewName, setOrgNewName] = useState("");
  const [orgNewOwner, setOrgNewOwner] = useState("");
  const orgMembers = selectedOrg?.members?.filter(
    (member) =>
      member.roleDesc === "SUPER_ADMIN" && member.status === "ACCEPTED",
  );

  const [popup, setPopup] = useState({
    popupState: false,
    popupType: "",
    popupTitle: "",
    popupSubtitle: "",
    popupSubtitle1: "",
    popupButton: false,
    popupCancel: false,
    popupCancelTitle: "",
    popupButtonTitle: "",
    popupButtonFunction: () => {},
    popupCancelFunction: () => {},
  });
  // popup
  const ActivatePopup = (type, message) => {
    if (type === "success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Organization Deleted",
        popupSubtitle: "The organization has been deleted successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate("/account/organizations-overview");
        },
      });
    } else if (type === "loading") {
      setPopup({
        popupState: true,
        popupType: "loading",
        popupTitle: "Deleting Organization...",
        popupSubtitle: "Please wait while we remove the organization.",
        popupCancel: false,
        popupButton: false,
      });
    } else if (type === "error") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: message || "Something went wrong",
        popupSubtitle: "An error occurred. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          navigate("/account/organizations-overview");
        },
      });
    } else if (type === "warning_basePlan") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Organization Deletion Not Allowed",
        popupSubtitle:
          "Your organization cannot be deleted while an active plan is in place. Please contact support for further assistance.",
        popupCancel: false,
        popupButton: true,
        popupCancelTitle: "Close",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonTitle: "Let's Connect",
        popupButtonFunction: () => {
          window.open("https://support.roconpaas.com/", "_blank");
          setPopup({ popupState: false });
        },
      });
    } else if (type === "deletion_in_progress") {
      setPopup({
        popupState: true,
        popupType: "info",
        popupTitle: "Deletion in Progress",
        popupSubtitle:
          "This organization is being deleted. You won't be able to access it while the deletion is running. We'll notify you once it's complete.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "warning_no_access") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "You don't have access",
        popupSubtitle: "Only the Owner or Super Admin can perform this action.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "warning_delete") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Delete Organization?",
        popupSubtitle:
          "All resources in this organization will be permanently deleted. Are you sure you want to continue?",
        popupCancel: true,
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButton: true,
        popupButtonTitle: "Yes",
        popupButtonFunction: () => {
          if (
            getRoleInOrg(emailId, selectedOrg) === "Owner" ||
            getRoleInOrg(emailId, selectedOrg) === "Super Admin"
          ) {
            ActivatePopup("loading");
            getStore().dispatch({
              type: Actions.DELETE_ORG,
              org: selectedOrg,
              meta: {
                onSuccess: () => {
                  setIsDeleting(false);
                  setPopup({ popupState: false });
                  setTimeout(() => {
                    ActivatePopup("success");
                  }, 300);
                },
                onError: () => {
                  setIsDeleting(false);
                  setPopup({ popupState: false });
                  setTimeout(() => {
                    ActivatePopup("error");
                  }, 300);
                },
              },
            });
          } else ActivatePopup("warning_no_access");
        },
      });
    } else if (type === "error_transfer") {
      setPopup({
        popupState: true,
        popupType: "error",
        popupTitle: "Ownership Transfer Failed",
        popupSubtitle:
          message || "We were unable to transfer ownership. Please try again.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setPopup({ popupState: false });
        },
      });
    } else if (type === "warning_transfer") {
      setPopup({
        popupState: true,
        popupType: "warning",
        popupTitle: "Transfer Organization Ownership?",
        popupSubtitle:
          "Are you sure you want to transfer ownership of this organization?",
        popupCancel: true,
        popupButton: true,
        popupButtonTitle: "Yes",
        popupCancelTitle: "No",
        popupCancelFunction: () => {
          setPopup({ popupState: false });
        },
        popupButtonFunction: () => {
          setPopup({ popupState: false });
          setTransferLoading(true);
          getStore().dispatch({
            type: Actions.CHANGE_ORG_OWNER,
            org: selectedOrg,
            orgNewOwner: orgNewOwner,
            meta: {
              onSuccess: () => {
                ActivatePopup("success_transfer");
                getStore().dispatch({
                  type: Actions.API_GET_SELECTED_ORG_FULL_INFO,
                });
              },
              onError: () => {
                setTransferLoading(false);
                ActivatePopup("error_transfer");
              },
            },
          });
        },
      });
    } else if (type === "success_transfer") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Ownership Transferred",
        popupSubtitle:
          "The organization ownership has been updated successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setTransferLoading(false);
          setPopup({ popupState: false });
        },
      });
    } else if (type === "name_change_success") {
      setPopup({
        popupState: true,
        popupType: "success",
        popupTitle: "Organization Renamed",
        popupSubtitle: "The organization name has been changed successfully.",
        popupCancel: false,
        popupButton: true,
        popupButtonTitle: "Ok",
        popupButtonFunction: () => {
          setOrgNewName("");
          navigate(`/account/${orgId}/settings`);
          getStore().dispatch({
            type: Actions.API_SELECTED_ORG,
            orgId: orgId,
          });
          setPopup({ popupState: false });
        },
      });
    } else if (type === "none") {
      setPopup({ popupState: false });
    }
  };

  useEffect(() => {
    if (orgNewName?.length >= 3) {
      const myTimeout = setTimeout(() => {
        if (orgNewName?.length >= 3) {
          setNameLoading(true);
          getStore().dispatch({
            type: Actions.API_IS_VALID_ORG,
            orgName: orgNewName,
            meta: {
              onSuccess: () => {
                setNameLoading(false);
                setNameValid(true);
              },
              onError: () => {
                setNameLoading(false);
                setNameValid(false);
                setNameError(true);
                setNameErrorMessage("Organization Already Exists");
              },
            },
          });
        }
      }, 500);

      return () => {
        clearTimeout(myTimeout);
      };
    } else {
      setNameValid(false);
    }
  }, [orgNewName]);

  const handleValueChange = (e) => {
    const newValue = e
      .replace(/[^a-zA-Z0-9\s]/g, "")
      .replace(/\s{2,}/g, " ")
      .replace(/^\s+/, "");
    if (newValue.length <= 24) {
      setOrgNewName(newValue);
    }
    if (newValue.length > 24) {
      setNameError(true);
      setNameErrorMessage("Maximum allowed characters are 24");
    } else if (newValue.length < 3) {
      setNameError(true);
      setNameErrorMessage("Minimum allowed characters are 3");
    } else {
      setNameError(false);
      setNameErrorMessage("");
    }
  };

  const handleSaveClick = () => {
    if (
      getRoleInOrg(emailId, selectedOrg) === "Owner" ||
      getRoleInOrg(emailId, selectedOrg) === "Super Admin"
    ) {
      setSaveNameLoading(true);

      getStore().dispatch({
        type: Actions.CHANGE_ORG_NAME,
        org: selectedOrg,
        orgNewName: orgNewName,
        meta: {
          onSuccess: () => {
            setSaveNameLoading(false);
            ActivatePopup("name_change_success");
          },
          onError: () => {
            setSaveNameLoading(false);
          },
        },
      });
    } else ActivatePopup("warning_no_access");
  };

  const deleteOrg = () => {
    if (selectedOrg?.deletionInProgress) {
      ActivatePopup("deletion_in_progress");
      return;
    }
    setIsDeleting(true);
    if (basePlan?.length > 0) {
      if ((cancel === true && daysAfterExpiry >= 2) || daysAfterExpiry >= 2) {
        ActivatePopup("warning_delete");
      } else {
        ActivatePopup("warning_basePlan");
      }
    } else {
      ActivatePopup("warning_delete");
    }
  };

  const handleUploadPopupOpen = () => {
    if (
      getRoleInOrg(emailId, selectedOrg) === "Owner" ||
      getRoleInOrg(emailId, selectedOrg) === "Super Admin"
    ) {
      setUploadImg(true);
    } else ActivatePopup("warning_no_access");
  };

  // const notificationSettings = [
  //   {
  //     title: "Product updates",
  //     subTitle: "News, announcements, and product updates.",
  //   },
  //   {
  //     title: "Security Updates",
  //     subTitle: "Important notifications about your account security.",
  //   },
  //   {
  //     title: "Security Updates",
  //     subTitle: "Important notifications about your account security.",
  //   },
  // ];

  return (
    <>
      {selectedOrg ? (
        <>
          <Grid2 className={OrgSettingsStyles.Container}>
            <Grid2 className={OrgSettingsStyles.header}>
              <Grid2>Settings</Grid2>
              <Grid2>
                {orgCountry === "USA" ? (
                  <Grid2 className={OrgSettingsStyles.countryContainer}>
                    <Usa />
                    <Grid2>USA</Grid2>
                  </Grid2>
                ) : (
                  <Grid2 className={OrgSettingsStyles.countryContainer}>
                    <Indian />
                    <Grid2>India</Grid2>
                  </Grid2>
                )}
              </Grid2>
            </Grid2>
            <Grid2 className={OrgSettingsStyles.mobile}>
              <Grid2 className={OrgSettingsStyles.transfer}>
                <Grid2 container>
                  <Grid2 className={OrgSettingsStyles.currentLabel}>
                    Current Organization Name is{" "}
                  </Grid2>
                  <Grid2 className={OrgSettingsStyles.currentName}>
                    {orgName}
                  </Grid2>
                </Grid2>
                <Grid2 className={OrgSettingsStyles.newNameContainer}>
                  <CustomInput
                    placeholder={"Enter new name"}
                    value={orgNewName.toLowerCase()}
                    setValue={handleValueChange}
                    nameLoading={nameLoading}
                    suffix={
                      orgNewName?.length > 0 ? (
                        nameLoading ? (
                          <CircularProgress size={20} />
                        ) : nameValid ? (
                          <CheckCircleOutlineOutlinedIcon
                            style={{ color: "green" }}
                          />
                        ) : nameValid === false ? (
                          <HighlightOffIcon style={{ color: "red" }} />
                        ) : null
                      ) : null
                    }
                    error={nameError}
                    errorMessage={nameErrorMessage}
                  />
                  <Grid2 className={OrgSettingsStyles.saveButtonContainer}>
                    <CustomButton
                      onClick={handleSaveClick}
                      disabled={!nameValid}
                    >
                      {saveNameLoading ? (
                        <CircularProgress size={20} color="#ffffff" />
                      ) : (
                        "Save"
                      )}
                    </CustomButton>
                  </Grid2>
                </Grid2>
                <Grid2 className={OrgSettingsStyles.transferContainer}>
                  <Transfer
                    title="Transfer"
                    subTitle="Ownership can only be transferred by Organization owner. This action can only be undone by the new owner"
                    currentOwner={orgOwner}
                    orgMembers={orgMembers}
                    onSelect={setOrgNewOwner}
                    onClick={() => ActivatePopup("warning_transfer")}
                    value={orgNewOwner}
                    selectedOrg={selectedOrg}
                    loading={transferLoading}
                  />
                  <DeleteComponent
                    title="Delete Organization"
                    subTitle={
                      "Delete your Organization and all of your source data, sites and any associated data. This is irreversible."
                    }
                    onClick={deleteOrg}
                    loading={isDeleting}
                  />
                </Grid2>
              </Grid2>
              <Grid2
                style={{ cursor: "pointer" }}
                onClick={handleUploadPopupOpen}
              >
                <UploadImage imagePath={imagePath} selectedOrg={selectedOrg} />
              </Grid2>
            </Grid2>

            {/* disabled until emailNotifications API is integrated */}
            <Grid2>
              {/* <EmailNotifications
             notifications={notificationSettings}
            // isEnabled={isEnabled}
            // onToggle={handleToggle}
          /> */}
            </Grid2>
          </Grid2>
        </>
      ) : (
        <PageLoading />
      )}

      <EditOrgImage
        uploadImg={uploadImg}
        setUploadImg={setUploadImg}
        loading={loading}
        setLoading={setLoading}
        orgId={orgId}
        image={imagePath}
      />

      <section>
        <FormPopup
          trigger={popup.popupState}
          setTrigger={setPopup}
          type={popup.popupType}
          title={popup.popupTitle}
          subtitle={popup.popupSubtitle}
          button={popup.popupButton}
          cancel={popup.popupCancel}
          cancelTitle={popup.popupCancelTitle}
          cancelFunction={popup.popupCancelFunction}
          buttonTitle={popup.popupButtonTitle}
          buttonFunction={popup.popupButtonFunction}
        />
      </section>
    </>
  );
}

export default OrganizationSettings;
